<div class="modal-header">
  <h4 class="modal-title">
    {{ title | translate }}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">

    <form [formGroup]="editForm" (submit)="accept()">
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label font-weight-bold">{{'editArticlePopup.label.name' | translate}}: </label>
        <div class="col-md-8">
          <input class="form-control" type="text" spellcheck="false" appInputAutoFocus
            inputRestricter="^[_.:;,\\! \+\-\(\)\pL\pN]*$"
            [readonly]="articleCollection && articleCollection.type !== ARTICLE_COLLECTION_NORMAL_TYPE"
            [class.is-invalid]="checkControlValidity('articleCollectionName')" formControlName="articleCollectionName"
            [class.input-error]="!editForm.controls['articleCollectionName'].valid && editForm.controls.articleCollectionName.touched">
          <div class="invalid-feedback">{{editForm.controls['articleCollectionName'].errors?.messageKey | translate}}
          </div>
        </div>
      </div>
    </form>

    <div *ngIf="articleCollection">
      <div class="mb-3 row">
        <label class="col-md-4 col-form-label font-weight-bold">{{'editArticlePopup.label.sorting' | translate}}:</label>
        <div class="col-md-8">
          <div class="form-check">
            <input type="radio" class="form-check-input" id="radio1" name="radioGroup" [value]="articlesSorting[0]"
              [(ngModel)]="currentSorting" (change)="sortArticles()">
            <label class="form-check-label" for="radio1" [innerHTML]="'editArticlePopup.article_number' | translate"></label>
          </div>
          <div class="form-check mt-3">
            <input type="radio" class="form-check-input" id="radio2" name="radioGroup" [value]="articlesSorting[1]"
              [(ngModel)]="currentSorting" (change)="sortArticles()">
            <label class="form-check-label" for="radio2" [innerHTML]="getCustomArticleNumberMappingLabel()"></label>
          </div>
        </div>
      </div>
      <div class="w-100">
        <table class="table table-striped fixed-layout" fixedHeader>
          <thead>
            <tr>
              <th class="break-all">{{'editArticlePopup.article_number' | translate}}</th>
              <th class="break-all">{{'editArticlePopup.own_article_number' | translate}}</th>
              <th width="40px"></th>
            </tr>
          </thead>
        </table>
        <div class="overflow-xh" style="min-height: 180px" maxHeightOffset="400">
          <table class="table table-striped fixed-layout mb-0">
            <tbody minRowCount [update]="update">
              <tr *ngFor="let article of collectionArticles; let i = index">
                <td class="break-all">{{article?.articleNo}}</td>
                <td class="break-all">{{getCustomArticleNumberLabel(article)}}</td>
                <td class="text-end" width="40px">
                  <a tooltip [tooltipText]="'sidebar.clear' | translate" (click)="removeArticleFromArticleCollection(article, articleCollection)" favoriteRowDelete>
                    <app-svg-icon type="delete" size="medium-small"/>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="edit-links small pt-2">
        <a class="link" (click)="editArticleNumberMappingPopup()">
          <app-svg-icon type="edit-pen" [inline]="true"/>  {{'ChoiceActionSetting.label.edit_article_numbers' | translate}}
        </a>
      </div>
    </div>

  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" type="button" (mousedown)="$event.preventDefault()"
    (click)="editForm.markAsUntouched(); close()">
    {{'global.label.cancel' | translate}}
  </button>
  <button class="btn btn-primary btn-forward" data-testid="create-collection-apply" type="submit" (click)="accept()">
    {{ articleCollection ? ('global.label.apply' | translate) : ('global.label.accept' | translate) }}
  </button>
</div>
